/**
 * BILLING ASSIGNMENT — plan-014 D1a (design §27.3.5, FR12-BIL-03; ADR 0034 decisions 1–3).
 *
 * A `billing_assignment` says which billing account, under which commercial terms, funds one workspace's NEW
 * activity over a half-open period `[from, until)`. Exactly one is in force per workspace at any instant —
 * migration 0080's exclusion constraint refuses a second (SQLSTATE 23P01), so this is a database fact, not a
 * convention. A change closes the current row and inserts its successor in one db_transaction
 * (`replaceEffective`, `packages/db/src/tenant/effective-dated.ts`); a conversation pins its
 * `billingAssignmentId` at admission (D2) and is never re-resolved by time.
 *
 * Only the billing-context resolver (D1b) reads assignments for a decision; everything else asks it.
 */
import { idCodec } from "../id/brand.js";
/** Parse / guard / mint for {@link BillingAssignmentId}. */
export const billingAssignmentIdCodec = idCodec("BillingAssignmentId");
/** Whether `period` contains `instant` — `[from, until)`, so a row is not in force at its own `until`. */
export function isInForceAt(period, instant) {
    const at = instant.getTime();
    return at >= period.from.getTime() && (period.until === null || at < period.until.getTime());
}
/** Why an assignment was written — `billing_assignment.source`, the CHECK of migration 0080. */
export const BILLING_ASSIGNMENT_SOURCE = [
    "creation",
    "workspace_creation",
    "funding_change",
    "subscription_change",
    "migration",
];
//# sourceMappingURL=assignment.js.map